import React, { useState, useEffect } from "react"
import { useSearchParams } from "react-router-dom"
import { cn } from "lib/utils"

export default function Pagination({
  totalRecords,
  currentPage,
  recordsPerPage,
  className=""
} : {
  totalRecords:number
  currentPage:number
  recordsPerPage:number 
  className?:string
}){

  const [ searchParams, setSearchParams ] = useSearchParams()
  const [ paginationStats, setPaginationStats ] = useState<any>({ totalPages: 0, startPage: 0, endPage: 0 })

  function updateSearchParam(key: string, value: string) {
    const currentParams = Object.fromEntries(searchParams.entries());
    setSearchParams({ ...currentParams, [key]: value });
  }
  
  const calculatePagination = () => {
    const totalPages = Math.ceil(totalRecords / recordsPerPage)
    const startPage = (currentPage - 1) * recordsPerPage + 1
    const endPage = Math.min(currentPage * recordsPerPage, totalRecords)
    setPaginationStats({ totalPages, startPage, endPage })
  }

  const handlePageClick = (page:number) => {
    updateSearchParam("_page", page.toString())
  }

  useEffect(() => { 
    calculatePagination()
  }, [totalRecords, currentPage, recordsPerPage])


  return (
    <div className={cn("w-full flex justify-center items-center gap-2", className)}>
      { Array.from({ length: paginationStats.totalPages }, (_, i) => (
        <div 
          key={i} 
          onClick={() => handlePageClick(i + 1)}
          className={cn(
            "px-[6px] py-[1px] border border-solid cursor-pointer",
            (i+1 == currentPage) ? "border-teal-600" : "border-transparent",
          )}
        >
          {i + 1} 
        </div>
      )) }
    </div>
  )
}